export const getTextFieldDefaultProps = () => {
  return {
    fullWidth: true,
    InputLabelProps: {
      shrink: true,
    },
    color: 'secondary',
  };
};

export const validationInputNumber = (e: React.ChangeEvent<HTMLInputElement>): number | "" => {
  const value: string = e.target.value;
  if (value === '') {
    return '';
  }
  if (!/^[1-9][0-9]?$/.test(value)) {
    return 1;
  }
  const numberValue: number = parseInt(value, 10);
  if (numberValue > 99) {
    return 99;
  }
  return numberValue;
};
